import { render, staticRenderFns } from "./kendaraanOperasional.vue?vue&type=template&id=13505cc6&"
import script from "./kendaraanOperasional.vue?vue&type=script&lang=js&"
export * from "./kendaraanOperasional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports